import * as $ from 'jquery';
import '@/css/styles.css';
import './PassiveListeners';
import {
	bootToTopBtn,
	bootTrigger,
} from "./common";
import bootCookie from '@/js/cookies/cookies';
import {searchHandler} from "./handlers/searchHandler";
import {recaptcha} from "./recaptcha";

document.querySelectorAll('form input, form textarea').forEach(el => {
	el.addEventListener('focus', () => {
		recaptcha();
	}, { once: true });
});

bootToTopBtn();
bootTrigger();
bootCookie();
searchHandler();

$(document).ready(function(){
    "use strict";
});
